<template>
  <div
    :style="`background-color: #f5f5f5;
      border: 2px solid #ea4444;
      border-radius: 10px;
      width: ${width}px;
      height: ${height}px`">

    <v-layout justify-center align-center fill-height class="pa-0 ma-0">
      <v-flex shrink>
        <v-img
          :src="require('@/../public/images/pdf.png').default"
          :height="height*0.6"
          :width="width*0.6"
          contain
        >
        </v-img>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    width:{
        type:Number,
        default: 405
    },
    height:{
        type:Number,
        default: 226
    },
  },
  mounted() {},
  methods: {},
  computed: {},
};
</script>
